import i18n from "i18n"

const API_URL = process.env.REACT_APP_API_URL
const WS_URL = process.env.REACT_APP_API_WS_URL
const BASE_URL = API_URL + "/api/v1"
const REFRESH_TOKEN_URL = API_URL + "/oauth/token"
const DEFAULT_PARAMS = { lang: i18n.language }

const API = {
  API_URL,
  BASE_URL,
  REFRESH_TOKEN_URL,
  WS_URL,
  DEFAULT_PARAMS
}

// The API's answer when a guest makes too many requests in a short time (e.g. promo code checks).
export const HTTP_STATUS_TOO_MANY_REQUESTS = 429

export default API
